module.exports = __webpack_public_path__ + "static/img/yongin-convergence.bbfadb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/yongin-convergence.jpg
// module id = 3ARQ
// module chunks = 0